import { Navigate } from 'react-router-dom'

/** Legacy route; resource library lives on /learn. */
export function LearnResourcesPage() {
  return <Navigate to="/learn#resource-library" replace />
}
